import { IconAdd, IconUpSide, IconRightSide, IconDownSide, IconLeftSide, IconArrowChevronUp, IconArrowChevronRight, IconArrowChevronLeft, IconArrowChevronDown, IconArrowUpDown, IconArea, IconAnalytics, IconAI, IconBuildingOffice1, IconBuildingOffice2, IconBuildingOffice3, IconCloseSign, IconCertification, IconCameraDome, IconCameraDomeCloud, IconCameraFisheye, IconCameraExternal, IconCameraMDC, IconCrowd, IconCgiSender, IconCameraPTZ, IconCameraTamp, IconDevice, IconDashboardSign, IconDocument, IconDrag, IconDashboards, IconDefocus, IconExport, IconEmail, IconEmpty, IconEvent, IconPlainFail, IconFail, IconFavorite, IconFolderClose, IconFolklift, IconFirmware, IconForkliftCounting, IconForkliftQueueManagement, IconForkliftHeatmap, IconFace, IconFogDetection, IconFocusNear, IconFocusFar, IconHeatmap, IconHeaterHeat, IconHeaterHeat1, IconInformationPlain, IconImageGallery, IconInformation, IconLive, IconLockOrg, IconLinkClip, IconLink1, IconLogOut1, IconLog1, IconLicensePlate, IconLineCrossing, IconMore, IconMotionDetection, IconNotifications, IconOnlineSuccessPlain, IconOnlineSuccess, IconObjectDetection, IconPlayback, IconPoE, IconPeople, IconPeopleVector, IconPeopleHeatmap, IconPTZ, IconQueueManagement, IconReset, IconRemove, IconReportsOld, IconRam, IconReports, IconRuleSetup, IconSetting, IconServerGateway, IconStorage, IconSpeakerSoundVolume, IconSpeakerSoundVolumeMute, IconSoftwareUpdate, IconSortArrowDown, IconSortArrowUp, IconSortArrowUpDown, IconSlipFall, IconShoppingCartCounting, IconShoppingCartQueueManagement, IconShoppingCartHeatmap, IconStoppedVehicle, IconShockDetection, IconTime, IconTopRank, IconTrafficJam, IconTooltipHelp, IconTooltipInfo, IconTamperingDetection, IconUserSingle, IconUserProfile, IconUserGroup, IconUnlinkClip, IconViewShow, IconViewHide, IconVideoLoss, IconVehicle, IconVehicleMotorcycle, IconVehicleBicycle, IconVehicleTruck, IconVehicleBus, IconVehicleVan, IconVehicleSedan, IconVehicleSuv, IconVehicleCounting, IconVehicleQueueManagement, IconVehicleHeatmap, IconWarning, IconWarningError, IconWarranty, IconWarrantyExpiration, IconLargeIconEmptyState, IconMediumForEmptyState, IconAlarm, IconApps, IconArrowRight, IconBookmark, IconCalendar, IconCheck, IconCloudUpload, IconCopy, IconCpu, IconDirection, IconEdit, IconExternalLink, IconFilter, IconFolderOpen, IconHelp, IconLeaf, IconLicense, IconList, IconLocation, IconLockOpen, IconMap, IconMenu, IconNetwork, IconNote, IconRefresh, IconSearch, IconServer, IconShare, IconShoppingCart, IconTemperature } from "../../assets/icons";
import {
  IconAddLargeLine,
  IconAddMediumLine,
  IconAiLargeLine,
  IconAlarmLargeLine,
  IconAnalyticsLargeFill,
  IconAnalyticsLargeLine,
  IconAppsLargeLine,
  IconAreaLargeLine,
  IconArrowChevronDownLargeLine,
  IconArrowChevronDownMediumLine,
  IconArrowChevronDownSmallFill,
  IconArrowChevronDownSmallLine,
  IconArrowChevronLeftLargeLine,
  IconArrowChevronLeftMediumLine,
  IconArrowChevronLeftSmallLine,
  IconArrowChevronRightLargeLine,
  IconArrowChevronRightMediumLine,
  IconArrowChevronRightSmallLine,
  IconArrowChevronUpLargeLine,
  IconArrowChevronUpMediumLine,
  IconArrowChevronUpSmallFill,
  IconArrowChevronUpSmallLine,
  IconArrowDownLargeFill,
  IconArrowDownLargeLine,
  IconArrowDownMediumLine,
  IconArrowElbowLargeLine,
  IconArrowLeftLargeLine,
  IconArrowLeftMediumLine,
  IconArrowNoneLargeLine,
  IconArrowRightLargeLine,
  IconArrowRightMediumLine,
  IconArrowUpDownLargeLine,
  IconArrowUpDownMediumLine,
  IconArrowUpDownSmallLine,
  IconArrowUpLargeFill,
  IconArrowUpLargeLine,
  IconArrowUpMediumLine,
  IconAutoFocusLargeLine,
  IconBookmarkLargeFill,
  IconBookmarkLargeLine,
  IconBuildingOffice1LargeFill,
  IconBuildingOffice1LargeLine,
  IconBuildingOffice2LargeLine,
  IconBuildingOffice3LargeLine,
  IconCalendarLargeLine,
  IconCameraDomeCloudError,
  IconCameraDomeCloudLargeLine,
  IconCameraDomeCloudOffline,
  IconCameraDomeCloudOnline,
  IconCameraDomeCloudWarning,
  IconCameraDomeError,
  IconCameraDomeLargeLine,
  IconCameraDomeOffline,
  IconCameraDomeOnline,
  IconCameraDomeWarning,
  IconCameraExternalError,
  IconCameraExternalLargeLine,
  IconCameraExternalOffline,
  IconCameraExternalOnline,
  IconCameraExternalWarning,
  IconCameraFisheyeError,
  IconCameraFisheyeLargeLine,
  IconCameraFisheyeOffline,
  IconCameraFisheyeOnline,
  IconCameraFisheyeWarning,
  IconCameraMDCError,
  IconCameraMDCExternalError,
  IconCameraMDCExternalOffline,
  IconCameraMDCExternalOnline,
  IconCameraMDCExternalWarning,
  IconCameraMDCLargeLine,
  IconCameraMDCOffline,
  IconCameraMDCOnline,
  IconCameraMDCWarning,
  IconCameraPTZLargeLine,
  IconCameraTampLargeLine,
  IconCertificationLargeLine,
  IconCgiSenderLargeLine,
  IconChatSupportLargeLine,
  IconCheckLargeLine,
  IconCloseLargeLine,
  IconCloudUploadLargeLine,
  IconCopyLargeLine,
  IconCpuLargeLine,
  IconCrowdCountingLargeLine,
  IconDashboardLargeLine,
  IconDashboardsLargeLine,
  IconDefocusLargeLine,
  IconDeviceLargeLine,
  IconDevices2LargeFill,
  IconDevices2LargeLine,
  IconDirectionLargeLine,
  IconDocumentLargeLine,
  IconDownloadImportLargeLine,
  IconDragLargeLine,
  IconDryHeaterLargeLine,
  IconDrySpinLargeLine,
  IconEditLargeLine,
  IconEmailLargeLine,
  IconEmptyLargeLine,
  IconEncoderError,
  IconEncoderLargeLine,
  IconEncoderOffline,
  IconEncoderOnline,
  IconEncoderWarning,
  IconErrorLargeFill,
  IconErrorLargeLine,
  IconEventLargeLine,
  IconExternalLinkLargeLine,
  IconFaceLargeLine,
  IconFailLargeFill,
  IconFailLargeLine,
  IconFavoriteLargeLine,
  IconFilterLargeLine,
  IconFirmwareLargeLine,
  IconFocusFarLargeLine,
  IconFocusNearLargeLine,
  IconFogDetectionLargeLine,
  IconFolderCloseLargeFill,
  IconFolderCloseLargeLine,
  IconFolderOpenLargeFill,
  IconFolderOpenLargeLine,
  IconFolkliftLargeLine,
  IconForkliftCountingLargeLine,
  IconForkliftHeatmapLargeLine,
  IconForkliftQueueManagementLargeLine,
  IconGpsLargeLine,
  IconGroupingLargeLine,
  IconHeatmapLargeLine,
  IconHelpLargeFill,
  IconHelpLargeLine,
  IconIdentitiesLargeFill,
  IconIdentitiesLargeLine,
  IconImageGalleryLargeLine,
  IconInformationLargeLine,
  IconKeyLargeLine,
  IconLanguageLargeLine,
  IconLicenseLargeLine,
  IconLicensePlateLargeLine,
  IconLineCrossingLargeLine,
  IconLinkClipLargeLine,
  IconLinkLargeLine,
  IconListLargeLine,
  IconLiveLargeLine,
  IconLocationLargeLine,
  IconLockLargeLine,
  IconLockOpenLargeLine,
  IconLogLargeFill,
  IconLogLargeLine,
  IconLogOutLargeLine,
  IconMapLargeLine,
  IconMenuLargeLine,
  IconMinusLargeLine,
  IconMoreLargeLine,
  IconMotionDetectionLargeLine,
  IconNetworkLargeLine,
  IconNoteLargeLine,
  IconNotificationLargeFill,
  IconNotificationLargeLine,
  IconObjectDetectionLargeLine,
  IconOnlineSuccessLargeFill,
  IconOnlineSuccessLargeLine,
  IconPanelCollapseLargeLine,
  IconPanelExpansionLargeLine,
  IconPeopleCountingLargeFill,
  IconPeopleCountingLargeLine,
  IconPeopleHeatmapLargeLine,
  IconPeopleLargeLine,
  IconPin2LargeFill,
  IconPin2LargeLine,
  IconPinLargeFill,
  IconPinLargeLine,
  IconPlaybackLargeLine,
  IconPoEError,
  IconPoELargeLine,
  IconPoEOffline,
  IconPoEOnline,
  IconPoEWarning,
  IconPTZLargeLine,
  IconQueueManagementLargeLine,
  IconRamLargeLine,
  IconRefreshLargeLine,
  IconRemoveLargeFill,
  IconRemoveLargeLine,
  IconReportsLargeFill,
  IconReportsLargeLine,
  IconResetLargeLine,
  IconRuleSetupLargeLine,
  IconSearchLargeLine,
  IconServerError,
  IconServerGatewayError,
  IconServerGatewayLargeLine,
  IconServerGatewayOffline,
  IconServerGatewayOnline,
  IconServerGatewayWarning,
  IconServerLargeLine,
  IconServerOffline,
  IconServerOnline,
  IconServerWarning,
  IconSettingLargeFill,
  IconSettingLargeLine,
  IconShareLargeLine,
  IconShockDetectionLargeLine,
  IconShoppingCartCountingLargeLine,
  IconShoppingCartHeatmapLargeLine,
  IconShoppingCartLargeLine,
  IconShoppingCartQueueManagementLargeLine,
  IconSlipFallLargeLine,
  IconSoftwareUpdateLargeLine,
  IconSortArrowDownLargeLine,
  IconSortArrowDownMediumLine,
  IconSortArrowUpDownLargeLine,
  IconSortArrowUpDownMediumLine,
  IconSortArrowUpLargeLine,
  IconSortArrowUpMediumLine,
  IconSpeakerSoundVolumeLargeLine,
  IconSpeakerSoundVolumeMuteLargeLine,
  IconStoppedVehicleLargeLine,
  IconStorageError,
  IconStorageLargeLine,
  IconStorageOffline,
  IconStorageOnline,
  IconStorageWarning,
  IconTamperingDetectionLargeLine,
  IconTemperatureLargeLine,
  IconTimeLargeLine,
  IconTopRankLargeLine,
  IconTrafficJamLargeLine,
  IconUnlinkClipLargeLine,
  IconUploadExportLargeLine,
  IconUserGroupLargeLine,
  IconUserGuideLargeLine,
  IconUserLargeFill,
  IconUserLargeLine,
  IconUserProfileLargeFill,
  IconUserProfileLargeLine,
  IconVehicleBicycleLargeLine,
  IconVehicleBusLargeLine,
  IconVehicleCountingLargeLine,
  IconVehicleHeatmapLargeLine,
  IconVehicleLargeLine,
  IconVehicleMotorcycleLargeLine,
  IconVehicleQueueManagementLargeLine,
  IconVehicleSedanLargeLine,
  IconVehicleSuvLargeLine,
  IconVehicleTruckLargeLine,
  IconVehicleVanLargeLine,
  IconVideoLossLargeLine,
  IconViewHideLargeLine,
  IconViewShowLargeLine,
  IconWarningErrorLargeFill,
  IconWarningErrorLargeLine,
  IconWarrantyExpirationLargeLine,
  IconWarrantyLargeLine,
} from "../../assets/newIcons";

export type IconKey = keyof typeof iconList;
export type OldIconKey = keyof typeof oldIconList;

export const oldIconList = {
  add: IconAdd,
  "arrow-up": IconUpSide,
  "arrow-right": IconRightSide,
  "arrow-down": IconDownSide,
  "arrow-left": IconLeftSide,
  "arrow-chevron-up": IconArrowChevronUp,
  "arrow-chevron-right": IconArrowChevronRight,
  "arrow-chevron-left": IconArrowChevronLeft,
  "arrow-chevron-down": IconArrowChevronDown,
  "arrow-up-down": IconArrowUpDown,
  alarm: IconAlarm,
  apps: IconApps,
  area: IconArea,
  analytics: IconAnalytics,
  AI: IconAI,
  bookmark: IconBookmark,
  "building-office1": IconBuildingOffice1,
  "building-office2": IconBuildingOffice2,
  "building-office3": IconBuildingOffice3,
  check: IconCheck,
  calendar: IconCalendar,
  close: IconCloseSign,
  copy: IconCopy,
  certification: IconCertification,
  "camera-dome": IconCameraDome,
  "camera-dome-cloud": IconCameraDomeCloud,
  "camera-fisheye": IconCameraFisheye,
  "camera-external": IconCameraExternal,
  "camera-MDC": IconCameraMDC,
  crowd: IconCrowd,
  cpu: IconCpu,
  "cgi-sender": IconCgiSender,
  "camera-PTZ": IconCameraPTZ,
  "camera-tamp": IconCameraTamp,
  "cloud-upload": IconCloudUpload,
  device: IconDevice,
  dashboard: IconDashboardSign,
  document: IconDocument,
  drag: IconDrag,
  dashboards: IconDashboards,
  direction: IconDirection,
  defocus: IconDefocus,
  "external-link": IconExternalLink,
  export: IconExport,
  edit: IconEdit,
  email: IconEmail,
  empty: IconEmpty,
  event: IconEvent,
  fail: IconPlainFail,
  "fail-snackbar": IconFail,
  favorite: IconFavorite,
  filter: IconFilter,
  "folder-close": IconFolderClose,
  "Folder-open": IconFolderOpen,
  folklift: IconFolklift,
  firmware: IconFirmware,
  "forklift-counting": IconForkliftCounting,
  "forklift-queue-management": IconForkliftQueueManagement,
  "forklift-heatmap": IconForkliftHeatmap,
  face: IconFace,
  "fog-detection": IconFogDetection,
  "focus-near": IconFocusNear,
  "focus-far": IconFocusFar,
  help: IconHelp,
  heatmap: IconHeatmap,
  "heater-heat": IconHeaterHeat,
  "heater-heat-1": IconHeaterHeat1,
  information: IconInformationPlain,
  "image-gallery": IconImageGallery,
  "information-filled": IconInformation,
  location: IconLocation,
  live: IconLive,
  lock: IconLockOrg,
  "lock-open": IconLockOpen,
  "link-clip": IconLinkClip,
  list: IconList,
  link: IconLink1,
  "log-out": IconLogOut1,
  license: IconLicense,
  log: IconLog1,
  "license-plate": IconLicensePlate,
  "line-crossing": IconLineCrossing,
  more: IconMore,
  "motion-detection": IconMotionDetection,
  map: IconMap,
  menu: IconMenu,
  notification: IconNotifications,
  note: IconNote,
  network: IconNetwork,
  "online-success": IconOnlineSuccessPlain,
  "online-success-filled": IconOnlineSuccess,
  "object-detection": IconObjectDetection,
  playback: IconPlayback,
  PoE: IconPoE,
  people: IconPeople,
  "people-vector": IconPeopleVector,
  "people-heatmap": IconPeopleHeatmap,
  PTZ: IconPTZ,
  "queue-management": IconQueueManagement,
  refresh: IconRefresh,
  reset: IconReset,
  remove: IconRemove,
  "reports-old": IconReportsOld,
  ram: IconRam,
  reports: IconReports,
  "rule-setup": IconRuleSetup,
  search: IconSearch,
  setting: IconSetting,
  share: IconShare,
  server: IconServer,
  "server-gateway": IconServerGateway,
  storage: IconStorage,
  "speaker-sound-volume": IconSpeakerSoundVolume,
  "speaker-sound-volume-mute": IconSpeakerSoundVolumeMute,
  "software-update": IconSoftwareUpdate,
  "sort-arrow-down": IconSortArrowDown,
  "sort-arrow-up": IconSortArrowUp,
  "sort-arrow-up-down": IconSortArrowUpDown,
  "slip-fall": IconSlipFall,
  "shopping-cart": IconShoppingCart,
  "shopping-cart-counting": IconShoppingCartCounting,
  "shopping-cart-queue-management": IconShoppingCartQueueManagement,
  "shopping-cart-heatmap": IconShoppingCartHeatmap,
  "stopped-vehicle": IconStoppedVehicle,
  "shock-detection": IconShockDetection,
  time: IconTime,
  "top-rank": IconTopRank,
  "traffic-jam": IconTrafficJam,
  temperature: IconTemperature,
  "tooltip-help": IconTooltipHelp,
  "tooltip-info": IconTooltipInfo,
  "tampering-detection": IconTamperingDetection,
  user: IconUserSingle,
  "user-profile": IconUserProfile,
  "user-group": IconUserGroup,
  "unlink-clip": IconUnlinkClip,
  "view-show": IconViewShow,
  "view-hide": IconViewHide,
  "video-loss": IconVideoLoss,
  vehicle: IconVehicle,
  "vehicle-motorcycle": IconVehicleMotorcycle,
  vehicle_bicycle: IconVehicleBicycle,
  "vehicle-truck": IconVehicleTruck,
  "vehicle-bus": IconVehicleBus,
  "vehicle-van": IconVehicleVan,
  "vehicle-sedan": IconVehicleSedan,
  "vehicle-suv": IconVehicleSuv,
  "vehicle-counting": IconVehicleCounting,
  "vehicle-queue-management": IconVehicleQueueManagement,
  "vehicle-heatmap": IconVehicleHeatmap,
  warning: IconWarning,
  "warning-error": IconWarningError,
  warranty: IconWarranty,
  "warranty-expiration": IconWarrantyExpiration,
  leaf: IconLeaf,
  "empty-state-large": IconLargeIconEmptyState,
  "empty-state-medium": IconMediumForEmptyState,
  "icon-arrow-right": IconArrowRight
};

const iconList = {
  "add-large-line": IconAddLargeLine,
  "add-medium-line": IconAddMediumLine,
  "AI-large-line": IconAiLargeLine,
  "alarm-large-line": IconAlarmLargeLine,
  "analytics-large-fill": IconAnalyticsLargeFill,
  "analytics-large-line": IconAnalyticsLargeLine,
  "apps-large-line": IconAppsLargeLine,
  "area-large-line": IconAreaLargeLine,
  "arrow_chevron_down-large-line": IconArrowChevronDownLargeLine,
  "arrow_chevron_down-medium-line": IconArrowChevronDownMediumLine,
  "arrow_chevron_down-small-fill": IconArrowChevronDownSmallFill,
  "arrow_chevron_down-small-line": IconArrowChevronDownSmallLine,
  "arrow_chevron_left-large-line": IconArrowChevronLeftLargeLine,
  "arrow_chevron_left-medium-line": IconArrowChevronLeftMediumLine,
  "arrow_chevron_left-small-line": IconArrowChevronLeftSmallLine,
  "arrow_chevron_right-large-line": IconArrowChevronRightLargeLine,
  "arrow_chevron_right-medium-line": IconArrowChevronRightMediumLine,
  "arrow_chevron_right-small-line": IconArrowChevronRightSmallLine,
  "arrow_chevron_up-large-line": IconArrowChevronUpLargeLine,
  "arrow_chevron_up-medium-line": IconArrowChevronUpMediumLine,
  "arrow_chevron_up-small-fill": IconArrowChevronUpSmallFill,
  "arrow_chevron_up-small-line": IconArrowChevronUpSmallLine,
  "arrow_down-large-fill": IconArrowDownLargeFill,
  "arrow_down-large-line": IconArrowDownLargeLine,
  "arrow_down-medium-line": IconArrowDownMediumLine,
  "arrow_elbow-large-line": IconArrowElbowLargeLine,
  "arrow_left-large-line": IconArrowLeftLargeLine,
  "arrow_left-medium-line": IconArrowLeftMediumLine,
  "arrow_none-large-line": IconArrowNoneLargeLine,
  "arrow_right-large-line": IconArrowRightLargeLine,
  "arrow_right-medium-line": IconArrowRightMediumLine,
  "arrow_up_down-large-line": IconArrowUpDownLargeLine,
  "arrow_up_down-medium-line": IconArrowUpDownMediumLine,
  "arrow_up_down-small-line": IconArrowUpDownSmallLine,
  "arrow_up-large-fill": IconArrowUpLargeFill,
  "arrow_up-large-line": IconArrowUpLargeLine,
  "arrow_up-medium-line": IconArrowUpMediumLine,
  "auto_focus-large-line": IconAutoFocusLargeLine,
  "bookmark-large-fill": IconBookmarkLargeFill,
  "bookmark-large-line": IconBookmarkLargeLine,
  "building_office1-large-fill": IconBuildingOffice1LargeFill,
  "building_office1-large-line": IconBuildingOffice1LargeLine,
  "building_office2-large-line": IconBuildingOffice2LargeLine,
  "building_office3-large-line": IconBuildingOffice3LargeLine,
  "calendar-large-line": IconCalendarLargeLine,
  "camera_dome_cloud-large-line": IconCameraDomeCloudLargeLine,
  "camera_dome-large-line": IconCameraDomeLargeLine,
  "camera_external-large-line": IconCameraExternalLargeLine,
  "camera_fisheye-large-line": IconCameraFisheyeLargeLine,
  "camera_MDC-large-line": IconCameraMDCLargeLine,
  "camera_PTZ-large-line": IconCameraPTZLargeLine,
  "camera_tamp-large-line": IconCameraTampLargeLine,
  "certification-large-line": IconCertificationLargeLine,
  "cgi_sender-large-line": IconCgiSenderLargeLine,
  "chat_support-large-line": IconChatSupportLargeLine,
  "check-large-line": IconCheckLargeLine,
  "close-large-line": IconCloseLargeLine,
  "cloud_upload-large-line": IconCloudUploadLargeLine,
  "copy-large-line": IconCopyLargeLine,
  "cpu-large-line": IconCpuLargeLine,
  "crowd_counting-large-line": IconCrowdCountingLargeLine,
  "dashboard-large-line": IconDashboardLargeLine,
  "dashboards-large-line": IconDashboardsLargeLine,
  "defocus-large-line": IconDefocusLargeLine,
  "device-large-line": IconDeviceLargeLine,
  "direction-large-line": IconDirectionLargeLine,
  "document-large-line": IconDocumentLargeLine,
  "download_import-large-line": IconDownloadImportLargeLine,
  "drag-large-line": IconDragLargeLine,
  "edit-large-line": IconEditLargeLine,
  "email-large-line": IconEmailLargeLine,
  "empty-large-line": IconEmptyLargeLine,
  "encoder-large-line": IconEncoderLargeLine,
  "error-large-fill": IconErrorLargeFill,
  "error-large-line": IconErrorLargeLine,
  "event-large-line": IconEventLargeLine,
  "external_link-large-line": IconExternalLinkLargeLine,
  "face-large-line": IconFaceLargeLine,
  "fail-large-fill": IconFailLargeFill,
  "fail-large-line": IconFailLargeLine,
  "favorite-large-line": IconFavoriteLargeLine,
  "filter-large-line": IconFilterLargeLine,
  "firmware-large-line": IconFirmwareLargeLine,
  "focus_far-large-line": IconFocusFarLargeLine,
  "focus_near-large-line": IconFocusNearLargeLine,
  "fog_detection-large-line": IconFogDetectionLargeLine,
  "folder_close-large-fill": IconFolderCloseLargeFill,
  "folder_close-large-line": IconFolderCloseLargeLine,
  "folder_open-large-fill": IconFolderOpenLargeFill,
  "folder_open-large-line": IconFolderOpenLargeLine,
  "folklift-large-line": IconFolkliftLargeLine,
  "forklift_counting-large-line": IconForkliftCountingLargeLine,
  "forklift_heatmap-large-line": IconForkliftHeatmapLargeLine,
  "forklift_queue_management-large-line": IconForkliftQueueManagementLargeLine,
  "grouping-large-line": IconGroupingLargeLine,
  "dry_heater-large-line": IconDryHeaterLargeLine,
  "dry_spin-large-line": IconDrySpinLargeLine,
  "heatmap-large-line": IconHeatmapLargeLine,
  "help-large-fill": IconHelpLargeFill,
  "help-large-line": IconHelpLargeLine,
  "identities-large-fill": IconIdentitiesLargeFill,
  "identities-large-line": IconIdentitiesLargeLine,
  "image_gallery-large-line": IconImageGalleryLargeLine,
  "information-large-line": IconInformationLargeLine,
  "key-large-line": IconKeyLargeLine,
  "language-large-line": IconLanguageLargeLine,
  "license_plate-large-line": IconLicensePlateLargeLine,
  "license-large-line": IconLicenseLargeLine,
  "line_crossing-large-line": IconLineCrossingLargeLine,
  "link_clip-large-line": IconLinkClipLargeLine,
  "link-large-line": IconLinkLargeLine,
  "list-large-line": IconListLargeLine,
  "live-large-line": IconLiveLargeLine,
  "location-large-line": IconLocationLargeLine,
  "lock_open-large-line": IconLockOpenLargeLine,
  "lock-large-line": IconLockLargeLine,
  "log_out-large-line": IconLogOutLargeLine,
  "log-large-line": IconLogLargeLine,
  "map-large-line": IconMapLargeLine,
  "menu-large-line": IconMenuLargeLine,
  "minus-large-line": IconMinusLargeLine,
  "more-large-line": IconMoreLargeLine,
  "motion_detection-large-line": IconMotionDetectionLargeLine,
  "network-large-line": IconNetworkLargeLine,
  "note-large-line": IconNoteLargeLine,
  "notification-large-fill": IconNotificationLargeFill,
  "notification-large-line": IconNotificationLargeLine,
  "object_detection-large-line": IconObjectDetectionLargeLine,
  "online_success-large-fill": IconOnlineSuccessLargeFill,
  "online_success-large-line": IconOnlineSuccessLargeLine,
  "panel_collapse-large-line": IconPanelCollapseLargeLine,
  "panel_expansion-large-line": IconPanelExpansionLargeLine,
  "people_counting-large-fill": IconPeopleCountingLargeFill,
  "people_counting-large-line": IconPeopleCountingLargeLine,
  "people_heatmap-large-line": IconPeopleHeatmapLargeLine,
  "people-large-line": IconPeopleLargeLine,
  "pin-large-fill": IconPinLargeFill,
  "pin-large-line": IconPinLargeLine,
  "pin2-large-fill": IconPin2LargeFill,
  "pin2-large-line": IconPin2LargeLine,
  "playback-large-line": IconPlaybackLargeLine,
  "PoE-large-line": IconPoELargeLine,
  "PTZ-large-line": IconPTZLargeLine,
  "queue_management-large-line": IconQueueManagementLargeLine,
  "ram-large-line": IconRamLargeLine,
  "refresh-large-line": IconRefreshLargeLine,
  "remove-large-fill": IconRemoveLargeFill,
  "remove-large-line": IconRemoveLargeLine,
  "reports-large-fill": IconReportsLargeFill,
  "reports-large-line": IconReportsLargeLine,
  "reset-large-line": IconResetLargeLine,
  "rule_setup-large-line": IconRuleSetupLargeLine,
  "search-large-line": IconSearchLargeLine,
  "server_gateway-large-line": IconServerGatewayLargeLine,
  "server-large-line": IconServerLargeLine,
  "setting-large-fill": IconSettingLargeFill,
  "setting-large-line": IconSettingLargeLine,
  "share-large-line": IconShareLargeLine,
  "shock_detection-large-line": IconShockDetectionLargeLine,
  "shopping_cart_counting-large-line": IconShoppingCartCountingLargeLine,
  "shopping_cart_heatmap-large-line": IconShoppingCartHeatmapLargeLine,
  "shopping_cart_queue_management-large-line": IconShoppingCartQueueManagementLargeLine,
  "shopping_cart-large-line": IconShoppingCartLargeLine,
  "slip_fall-large-line": IconSlipFallLargeLine,
  "software_update-large-line": IconSoftwareUpdateLargeLine,
  "sort_arrow_down-large-line": IconSortArrowDownLargeLine,
  "sort_arrow_down-medium-line": IconSortArrowDownMediumLine,
  "sort_arrow_up_down-large-line": IconSortArrowUpDownLargeLine,
  "sort_arrow_up_down-medium-line": IconSortArrowUpDownMediumLine,
  "sort_arrow_up-large-line": IconSortArrowUpLargeLine,
  "sort_arrow_up-medium-line": IconSortArrowUpMediumLine,
  "speaker_sound_volume_mute-large-line": IconSpeakerSoundVolumeMuteLargeLine,
  "speaker_sound_volume-large-line": IconSpeakerSoundVolumeLargeLine,
  "stopped_vehicle-large-line": IconStoppedVehicleLargeLine,
  "storage-large-line": IconStorageLargeLine,
  "tampering_detection-large-line": IconTamperingDetectionLargeLine,
  "temperature-large-line": IconTemperatureLargeLine,
  "time-large-line": IconTimeLargeLine,
  "top_rank-large-line": IconTopRankLargeLine,
  "traffic_jam-large-line": IconTrafficJamLargeLine,
  "unlink_clip-large-line": IconUnlinkClipLargeLine,
  "upload_export-large-line": IconUploadExportLargeLine,
  "user_group-large-line": IconUserGroupLargeLine,
  "user_guide-large-line": IconUserGuideLargeLine,
  "user_profile-large-fill": IconUserProfileLargeFill,
  "user_profile-large-line": IconUserProfileLargeLine,
  "user-large-fill": IconUserLargeFill,
  "user-large-line": IconUserLargeLine,
  "vehicle_bicycle-large-line": IconVehicleBicycleLargeLine,
  "vehicle_bus-large-line": IconVehicleBusLargeLine,
  "vehicle_counting-large-line": IconVehicleCountingLargeLine,
  "vehicle_heatmap-large-line": IconVehicleHeatmapLargeLine,
  "vehicle_motorcycle-large-line": IconVehicleMotorcycleLargeLine,
  "vehicle_queue_management-large-line": IconVehicleQueueManagementLargeLine,
  "vehicle_sedan-large-line": IconVehicleSedanLargeLine,
  "vehicle_suv-large-line": IconVehicleSuvLargeLine,
  "vehicle_truck-large-line": IconVehicleTruckLargeLine,
  "vehicle_van-large-line": IconVehicleVanLargeLine,
  "vehicle-large-line": IconVehicleLargeLine,
  "video_loss-large-line": IconVideoLossLargeLine,
  "view_hide-large-line": IconViewHideLargeLine,
  "view_show-large-line": IconViewShowLargeLine,
  "warning_error-large-fill": IconWarningErrorLargeFill,
  "warning_error-large-line": IconWarningErrorLargeLine,
  "warranty_expiration-large-line": IconWarrantyExpirationLargeLine,
  "warranty-large-line": IconWarrantyLargeLine,
  "log-large-fill": IconLogLargeFill,
  "camera_dome_cloud-error": IconCameraDomeCloudError,
  "camera_dome_cloud-offline": IconCameraDomeCloudOffline,
  "camera_dome_cloud-online": IconCameraDomeCloudOnline,
  "camera_dome_cloud-warning": IconCameraDomeCloudWarning,
  "camera_dome-error": IconCameraDomeError,
  "camera_dome-offline": IconCameraDomeOffline,
  "camera_dome-online": IconCameraDomeOnline,
  "camera_dome-warning": IconCameraDomeWarning,
  "camera_external-error": IconCameraExternalError,
  "camera_external-offline": IconCameraExternalOffline,
  "camera_external-online": IconCameraExternalOnline,
  "camera_external-warning": IconCameraExternalWarning,
  "camera_fisheye-error": IconCameraFisheyeError,
  "camera_fisheye-offline": IconCameraFisheyeOffline,
  "camera_fisheye-online": IconCameraFisheyeOnline,
  "camera_fisheye-warning": IconCameraFisheyeWarning,
  "camera_MDC_external-error": IconCameraMDCExternalError,
  "camera_MDC_external-offline": IconCameraMDCExternalOffline,
  "camera_MDC_external-online": IconCameraMDCExternalOnline,
  "camera_MDC_external-warning": IconCameraMDCExternalWarning,
  "camera_MDC-error": IconCameraMDCError,
  "camera_MDC-offline": IconCameraMDCOffline,
  "camera_MDC-online": IconCameraMDCOnline,
  "camera_MDC-warning": IconCameraMDCWarning,
  "Devices2-large-line": IconDevices2LargeLine,
  "Devices2-large-fill": IconDevices2LargeFill,
  "encoder-error": IconEncoderError,
  "encoder-offline": IconEncoderOffline,
  "encoder-online": IconEncoderOnline,
  "encoder-warning": IconEncoderWarning,
  "gps-large-line": IconGpsLargeLine,
  "PoE-error": IconPoEError,
  "PoE-offline": IconPoEOffline,
  "PoE-online": IconPoEOnline,
  "PoE-warning": IconPoEWarning,
  "server_gateway-error": IconServerGatewayError,
  "server_gateway-offline": IconServerGatewayOffline,
  "server_gateway-online": IconServerGatewayOnline,
  "server_gateway-warning": IconServerGatewayWarning,
  "server-error": IconServerError,
  "server-offline": IconServerOffline,
  "server-online": IconServerOnline,
  "server-warning": IconServerWarning,
  "storage-error": IconStorageError,
  "storage-offline": IconStorageOffline,
  "storage-online": IconStorageOnline,
  "storage-warning": IconStorageWarning,
};

export default iconList;
